import type { MRT_ColumnDef } from "mantine-react-table-open";
import { LAST_YEAR } from "../../../../utils/dates";
import type {
  DataAssessment,
  SiteOverviewSite,
  SiteStatusSite
} from "../../site-status-types";
import { getDataSufficientBaseColumn } from "./getDataSufficientBaseColumn";

function getGridMeterSufficientColumn(): MRT_ColumnDef<
  SiteOverviewSite | SiteStatusSite
> {
  return {
    header: `Netzverknüpfungspunkt-Daten ${LAST_YEAR}`,
    accessorFn: (rowData) =>
      getSiteDataAssessmentGridMakoMeter(rowData.siteDataAssessment),
    ...getDataSufficientBaseColumn()
  };
}

function getSiteDataAssessmentGridMakoMeter(
  siteDataAssessment?: DataAssessment
): boolean | null {
  if (!siteDataAssessment) {
    return null;
  }

  if (siteDataAssessment.gridMeterSufficient !== null) {
    return siteDataAssessment.gridMeterSufficient;
  } else if (siteDataAssessment.makoMeterDataIsSufficient !== null) {
    return siteDataAssessment.makoMeterDataIsSufficient;
  }

  return null;
}

export { getGridMeterSufficientColumn };
